@let useMobileLayout = useMobileLayout$ | async;

<div
  class="tw:w-full"
  [ngClass]="{
    'tw:max-w-2xl': useMobileLayout === false,
    'tw:mx-auto': useMobileLayout === false,
    'tw:pb-2': paddingBottom,
    'tw:h-full': !scrollX
  }"
>
  <ng-content></ng-content>
</div>
